export const chartColumns = (ctx) => {
  return [
    {
      field: ctx.serviceTypeName == '仓储服务' ? 'signingDate' : 'signDate',
      title: '签约时间',
      // width: '120',
    },
    {
      field: 'contractNo',
      title: '合同编号',
      // width: '150',
    },
    {
      field: 'paperContractNo',
      title: '纸质合同号',
      // width: '140',
    },
    {
      field: ctx.serviceTypeName == '仓储服务' ? 'projectCode' : 'projectNo',
      title: '项目编号',
      // width: '140',
    },
    {
      field: 'projectName',
      title: '项目名称',
      // width: '140',
      //fixme
    },
    {
      field: ctx.serviceTypeName == '仓储服务' ? 'businessDepartment' : 'parkDepartmentName',
      title: '业务部门',
      // width: '140',
    },
    {
      field: ctx.serviceTypeName == '仓储服务' ? 'signatoryName' : 'signPerson',
      title: '签约人',
      // width: '140',
    },
    {
      field: ctx.serviceTypeName == '仓储服务' ? 'dateStart' : 'contractValidFrom',
      title: '合同开始日期',
      // width: '140',
    },
    {
      field: ctx.serviceTypeName == '仓储服务' ? 'dateEnd' : 'contractValidUntil',
      title: '合同结束日期',
      // width: '140',
    },
  ];
};
